import React, { useState } from 'react'
import { editUserDetails, setTag } from '../../../Api Methods/Api';
import Input from '../../CustomDropDown/Input/Input';
import Button1 from '../../UI/Button/Button1';
import classes2 from "../../forms/InviteUserForm.module.css"
import DataManager from '../../../hooks/DataManager';
import { Button } from 'rsuite';
import { useDispatch } from 'react-redux';

const UpdateEmail = ({ placeholder, successModal, errorModal, HandleCloseModal, HandleShowModal, userObject, setUserObject}) => {

    const dataManager = new DataManager();
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const apiData = {
        token,
        client,
    }
    const [userEmail, setUserEmail] = useState(placeholder || "");
    const dispatch = useDispatch();
    const [showError, setShowError] = useState(false)

    const isValidEmail = (userEmail) => {
        if (userEmail && userEmail !== ""){
            return true
        }
        
        return false
    }

    const handleInputChange = (e) => {
        setUserEmail(e.target.value)
    }

    const HandleUpdateEmail = async () => {
        const body = {
            "userID": userObject.id,
            "columnName": "email",
            "newValue": userEmail
        }

        if (isValidEmail(userEmail)){
            const response = await editUserDetails(apiData, body, dispatch);
            if (response) {
                HandleCloseModal();
                successModal("Email address successfully updated");

                setUserObject((prevUserObject) => ({
                    ...prevUserObject,
                    email: userEmail
                }));

            } else {
                errorModal("Failed to update email address, please try again")
            }
        } else {
            setShowError(true)
        }
    }

    return (
        <form method="dialog" >
            {showError && <p className={classes2.errorMessage}>Please enter a valid email address</p>}
            <br></br>
            <Input
                type="text"
                value={userEmail}
                onChange={(e) => handleInputChange(e)}
                placeholder={placeholder}
            />
            <br></br>
            <br></br>
            <Button icon="pi pi-save"  onClick={HandleUpdateEmail} label="Save" severity='success'/>
        </form>
    )
}

export default UpdateEmail;